













































import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import { getModule } from "vuex-module-decorators";
import LongTrendPeriodModule from "@/store/clients/LongTrendPeriod.module";
import { LongTrendPeriodStatistics } from "@/types/longTrendPeriodStatistics";
import { ILongTrendPeriod } from "@/types/longTrendPeriod";

const LongTrendPeriod = getModule(LongTrendPeriodModule, store);

@Component
export default class StatisticsCard extends Vue {
  get statistics(): LongTrendPeriodStatistics | null {
    return LongTrendPeriod.statistics;
  }
  get longTrendPeriods(): ILongTrendPeriod | null {
    return LongTrendPeriod.longTrendPeriod;
  }
  get pointCount(): number | string {
    return this.longTrendPeriods?.longTrendData?.length ?? "N/A";
  }
  get isBenchmarking(): boolean {
    return this.longTrendPeriods?.isBenchmarking ?? false;
  }
  get averageMean(): number | string {
    return this.statistics?.averageMean ?? "N/A";
  }
  get correlation(): number | string {
    return this.statistics?.correlation ?? "N/A";
  }
  get diffPerMonth(): number | string {
    return this.statistics?.diffPerMonth ?? "N/A";
  }
  get diffPerYear(): number | string {
    return this.statistics?.diffPerYear ?? "N/A";
  }
  get standardDeviation(): number | string {
    return this.statistics?.standardDeviation ?? "N/A";
  }
  get trendFunction(): string {
    return this.statistics?.trendFunction ?? "N/A";
  }

  round(value: number | string, precision = 1): number | string {
    if (typeof value === "string") return value;
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }
}
